import React, { useState, useEffect, forwardRef } from "react";

import DatePicker from "react-datepicker";
import axios from "axios";

import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
registerLocale("fr", fr);

export default function Agenda() {
	const [date, setDate] = useState(new Date());
	const [sent, setSent] = useState(false);

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const userID = urlParams.get("id");
	const userName = urlParams.get("name");

	const InputDebut = forwardRef(({ value, onClick }, ref) => (
		<input
			className="mt-1 w-full shadow-lg cursor-pointer rounded-md border border-gray-400/50 bg-white p-2 text-left capitalize outline-none dark:bg-gray-700 dark:text-white"
			onClick={onClick}
			ref={ref}
			value={value}
			readOnly
			placeholder="Date évaluation"
		/>
	));

	const isWeekday = date => {
		const day = date.getDay(date);
		return day !== 0 && day !== 6;
	};

	const submitDate = async e => {
		e.preventDefault();

		try {
			await axios.post(
				"https://global-academie.herokuapp.com/avis/dateEvaluation",
				{
					date,
					userID,
					userName,
				}
			);
			setSent(true);
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<section className="w-full min-h-screen flex flex-col items-center justify-center">
			<form onSubmit={submitDate}>
				<h2 className="mb-4 text-3xl font-bold text-indigo-500">
					Choississez votre date d'évaluation
				</h2>
				<div className={sent ? "hidden" : ""}>
					<label className="pl-1 font-medium dark:text-indigo-200">
						Date
					</label>
					<DatePicker
						locale={fr}
						selected={date}
						onChange={date => setDate(date)}
						filterDate={isWeekday}
						dateFormat="dd/MM/yyyy HH:mm"
						minDate={new Date()}
						minTime={new Date(0, 0, 0, 10, 0)} // 10:00
						maxTime={new Date(0, 0, 0, 18, 0)} // 18:00
						showTimeSelect
						timeFormat="p"
						timeIntervals={15}
						customInput={<InputDebut />}
						isClearable
						placeholderText="Pp"
					/>
				</div>
				<button
					type="submit"
					disabled={!date || sent}
					className={
						sent
							? "mt-4 w-full rounded-md border-2 border-transparent bg-green-500 p-2 font-medium text-white transition-all duration-200 "
							: "mt-4 w-full rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200 hover:border-indigo-500 hover:bg-transparent hover:text-indigo-500"
					}
				>
					{sent ? "Merci, date enregistrée." : "Envoyer"}
				</button>
			</form>
		</section>
	);
}
